import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pos-wrapper grid m-0 justify-content-center" }
const _hoisted_2 = { class: "col-12 mt-0 mr-0 ml-0 surface-100" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "category-btn" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1rem"}
}, null, -1)
const _hoisted_7 = { class: "col-12 px-3 results-wrapper" }
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = { class: "col-12 flex justify-content-between" }
const _hoisted_10 = { class: "search-results-label" }
const _hoisted_11 = {
  key: 0,
  class: "search-result-item blue-text"
}
const _hoisted_12 = {
  key: 1,
  class: "search-result-item blue-text"
}
const _hoisted_13 = { class: "list-type-btn-wrapper" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-th-large" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-list" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "col-12 h-5"
}
const _hoisted_17 = {
  key: 1,
  class: "col-12"
}
const _hoisted_18 = {
  key: 0,
  class: "list-view",
  ref: "parts-table"
}
const _hoisted_19 = { class: "grid flex-wrap align-items-baseline justify-content-right gap-2 m-0 p-0" }
const _hoisted_20 = {
  key: 0,
  class: "card grid col lg:hidden p-0 pt-2 pr-2 justify-content-center ml-1"
}
const _hoisted_21 = { class: "pt-0 pb-1 px-3" }
const _hoisted_22 = {
  key: 1,
  class: "grid col p-0 m-0 hidden lg:flex"
}
const _hoisted_23 = { class: "pt-0 pb-1 px-3" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "kit-description block" }
const _hoisted_26 = { class: "part-number blue-text block" }
const _hoisted_27 = { class: "part-manufactured-description block" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "flex p-0 m-0 justify-content-center" }
const _hoisted_31 = { class: "kit-table-wrapper" }
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = { class: "kit-description block" }
const _hoisted_34 = { class: "blue-text part-number block" }
const _hoisted_35 = { class: "part-manufactured-description block" }
const _hoisted_36 = { class: "block strikethrough original-price" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "grid flex-wrap align-items-baseline justify-content-right gap-2 m-0 p-0 mb-2" }
const _hoisted_39 = {
  key: 0,
  class: "card grid col lg:hidden p-0 pt-2 pr-2 justify-content-center ml-1"
}
const _hoisted_40 = { class: "pt-0 pb-1 px-3" }
const _hoisted_41 = {
  key: 1,
  class: "grid col p-0 m-0 hidden lg:flex"
}
const _hoisted_42 = { class: "pt-0 pb-1 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_TreeSelect = _resolveComponent("TreeSelect")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ResultGridView = _resolveComponent("ResultGridView")!
  const _component_ProductDialog = _resolveComponent("ProductDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Search, {
          id: "priceSearchText",
          ref: "priceSearchText",
          label: "name",
          file: "PRICE",
          currentView: "Pos",
          placeHolder: "Search Or Enter Part Number",
          leftIcon: true,
          class: "large-search-input",
          onPriceSearch: _ctx.getPriceSearchResult,
          onIsSearching: _ctx.onIsSearchingParts,
          searchFunction: _ctx.lookupPrice,
          rangeEnd: _ctx.rangeEnd,
          rangeStart: _ctx.rangeStart,
          coCode: _ctx.getSelectedCoCode
        }, null, 8, ["onPriceSearch", "onIsSearching", "searchFunction", "rangeEnd", "rangeStart", "coCode"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.categories.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`col-12 ${_ctx.carrouselClass}`)
              }, [
                _createVNode(_component_Carousel, {
                  value: _ctx.categories,
                  numVisible: 14,
                  numScroll: 6,
                  page: _ctx.carouselPage,
                  "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => (_ctx.carouselPage = $event)),
                  responsiveOptions: _ctx.responsiveOptions
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Button, {
                        onClick: ($event: any) => (_ctx.searchCategory(slotProps.data)),
                        title: slotProps.data.description
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _createTextVNode(" " + _toDisplayString(slotProps.data.description || slotProps.data.category), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "title"])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "page", "responsiveOptions"])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode("Search Results For"),
                  (this.currentSearch === '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_Breadcrumb, {
                          home: _ctx.init,
                          model: _ctx.partSearch
                        }, null, 8, ["home", "model"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, " " + _toDisplayString(this.currentSearch), 1)),
                  _createTextVNode("-"),
                  _createElementVNode("span", null, " " + _toDisplayString(_ctx.updatedParts ? _ctx.updatedParts.length : 0) + " ", 1),
                  _createTextVNode(" products")
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchResultView(false))),
                    class: _normalizeClass(["bg-white list-type-btn", { unselected: _ctx.isResultsListView }])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_Button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchResultView(true))),
                    class: _normalizeClass(["bg-white list-type-btn", { unselected: !_ctx.isResultsListView }])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ]),
              (_ctx.isSearchingParts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_LoadingSpinner, { loading: "" })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_ctx.isResultsListView)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_DataTable, {
                            ref: "partsTable",
                            scrollable: "",
                            scrollHeight: "50vh",
                            paginator: "",
                            first: _ctx.page,
                            "onUpdate:first": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page) = $event)),
                            onPage: _ctx.onPage,
                            class: "p-datatable-sm",
                            "row-class": _ctx.rowClass,
                            rows: _ctx.rows,
                            "onUpdate:rows": _cache[6] || (_cache[6] = ($event: any) => (_ctx.rows = $event)),
                            expandedRows: _ctx.expandedRows,
                            "onUpdate:expandedRows": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.expandedRows) = $event)),
                            alwaysShowPaginator: true,
                            value: _ctx.parts,
                            dataKey: "part_no",
                            "selection-mode": "single",
                            onRowClick: _ctx.onRowClick,
                            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                            rowsPerPageOptions: [25, 50, 75],
                            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} Products",
                            responsiveLayout: "stack",
                            breakpoint: "768px"
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_19, [
                                (_ctx.parts.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createVNode(_component_TreeSelect, {
                                        modelValue: _ctx.selectedSmallFilterOptions,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSmallFilterOptions) = $event)),
                                        options: _ctx.smallFilterOptionsComputed,
                                        selectionMode: "checkbox",
                                        placeholder: "Select filter",
                                        class: "w-full small-parts-filter",
                                        display: "chip",
                                        ref: "nodes"
                                      }, {
                                        footer: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_21, [
                                            _createVNode(_component_Button, {
                                              type: "button",
                                              label: "Apply Filter",
                                              class: "w-12 h-2rem",
                                              onClick: _ctx.getFilteredParts
                                            }, null, 8, ["onClick"])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "options"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.parts.length > 0 && _ctx.getFilters.length !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilters, (filter, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: filter.label,
                                          class: "col-2 card flex justify-content-center p-0 pr-1 mb-1"
                                        }, [
                                          _createVNode(_component_MultiSelect, {
                                            modelValue: _ctx.selectedFilterOptions[index]!.value,
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.selectedFilterOptions[index]!.value) = $event),
                                            display: "chip",
                                            options: filter.tags,
                                            optionLabel: "label",
                                            placeholder: filter.label,
                                            class: "w-full",
                                            onChange: _ctx.removeMultiselectChip
                                          }, {
                                            footer: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_23, [
                                                _createVNode(_component_Button, {
                                                  type: "button",
                                                  label: "Apply Filter",
                                                  class: "w-12 h-2rem",
                                                  onClick: _ctx.getFilteredParts
                                                }, null, 8, ["onClick"])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange"])
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.parts.length > 0 && _ctx.getFilters.length > 0)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 2,
                                      icon: "pi pi-filter-slash",
                                      onClick: _ctx.clearFilters,
                                      class: "col-1 m-0"
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            expansion: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_DataTable, {
                                  class: "p-datatable-sm",
                                  value: slotProps.data.kitList
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, { class: "product-image-kit-column" }, {
                                      body: _withCtx(() => [
                                        (slotProps.data.image)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              class: "product-image",
                                              src: slotProps.data.image,
                                              alt: slotProps.data.desc
                                            }, null, 8, _hoisted_32))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_Column, {
                                      field: "name",
                                      class: "flex flex-column align-items-start justify-content-center name-kit-column xl:w-4"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(slotProps.data.kit), 1),
                                        _createElementVNode("span", _hoisted_34, _toDisplayString(slotProps.data.name), 1),
                                        _createElementVNode("span", _hoisted_35, "Part #" + _toDisplayString(slotProps.data.part) + " | Manufactured Part #" + _toDisplayString(slotProps.data.manufacturedPart), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_Column, {
                                      field: "quantity",
                                      class: "w-2"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_InputNumber, {
                                            class: "quantity-input",
                                            modelValue: slotProps.data.quantity,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.quantity) = $event),
                                            step: _ctx.calculateStep(slotProps.data),
                                            inputId: "horizontal-buttons",
                                            showButtons: "",
                                            buttonLayout: "horizontal",
                                            decrementButtonclass: "p-button-danger",
                                            incrementButtonclass: "p-button-success",
                                            incrementButtonIcon: "pi pi-plus",
                                            decrementButtonIcon: "pi pi-minus"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_Column, {
                                      field: "originalPrice",
                                      class: "original-price-kit-column"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        _createElementVNode("span", _hoisted_36, "$" + _toDisplayString(slotProps.data.originalPrice), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_Column, {
                                      class: "blue-text text-sm font-bold",
                                      field: "finalPrice"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        _createElementVNode("span", null, "$" + _toDisplayString(slotProps.data.finalPrice), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, { class: "product-image-column" }, {
                                body: _withCtx((slotProps) => [
                                  (slotProps.data.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "product-image",
                                        src: slotProps.data.image,
                                        alt: slotProps.data.desc
                                      }, null, 8, _hoisted_24))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                expander: "",
                                style: {},
                                class: "expander-bottom-btn"
                              }),
                              _createVNode(_component_Column, {
                                field: "part_number",
                                class: "flex flex-column align-items-baseline kit-description-wrapper"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(slotProps.data.kit), 1),
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(slotProps.data.desc
                          ? slotProps.data.desc
                          : "NO DESCRIPTION AVAILABLE"), 1),
                                  _createElementVNode("span", _hoisted_27, [
                                    _createTextVNode("Part #" + _toDisplayString(slotProps.data.altcode1 || slotProps.data.part_number) + " ", 1),
                                    (slotProps.data.code)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "| Code #: " + _toDisplayString(slotProps.data.code), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                class: "justify-content-center tag-column",
                                field: "onHand"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createVNode(_component_Tag, {
                                    severity: 
                          _ctx.handleOnHandTagColor(
                            data.available !== undefined
                              ? parseInt(data.available)
                              : parseInt(data.avail_qty) || 0
                          )
                        ,
                                    value: 
                          _ctx.handleOnHandTagText(
                            data.available !== undefined
                              ? parseInt(data.available)
                              : parseInt(data.avail_qty) || 0
                          )
                        ,
                                    rounded: "",
                                    class: "text-center on-hand-tag"
                                  }, null, 8, ["severity", "value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                class: "blue-text font-bold code-price-wrapper",
                                field: "price"
                              }, {
                                body: _withCtx((slotProps) => [
                                  (slotProps.data.price)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.formatPrice(slotProps.data.price)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "quantity",
                                class: "quantity-wrapper"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createElementVNode("div", {
                                    onClick: _cache[4] || (_cache[4] = (event) => event.stopPropagation())
                                  }, [
                                    _createVNode(_component_InputNumber, {
                                      class: "quantity-input",
                                      modelValue: slotProps.data.quantity,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.quantity) = $event),
                                      inputId: "horizontal-buttons",
                                      min: 0,
                                      step: _ctx.calculateStep(slotProps.data),
                                      showButtons: "",
                                      buttonLayout: "horizontal",
                                      decrementButtonclass: "p-button-danger",
                                      incrementButtonclass: "p-button-success",
                                      incrementButtonIcon: "pi pi-plus",
                                      decrementButtonIcon: "pi pi-minus",
                                      onInput: ($event: any) => (_ctx.updatePrice($event, slotProps.data))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onInput"])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, { class: "cart-wrapper" }, {
                                body: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_Button, {
                                      class: "add-to-cart-btn pl-2 pr-2 xl:pl-3 xl:pr-3",
                                      style: _normalizeStyle(_ctx.buttonColor(slotProps.data.quantity)),
                                      label: "Add to Cart",
                                      onClick: ($event: any) => (_ctx.addItem(slotProps.data))
                                    }, null, 8, ["style", "onClick"])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["first", "onPage", "row-class", "rows", "expandedRows", "value", "onRowClick"])
                        ], 512))
                      : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            (_ctx.parts.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createVNode(_component_TreeSelect, {
                                    modelValue: _ctx.selectedSmallFilterOptions,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedSmallFilterOptions) = $event)),
                                    options: _ctx.smallFilterOptionsComputed,
                                    selectionMode: "checkbox",
                                    placeholder: "Select filter",
                                    class: "w-full small-parts-filter",
                                    display: "chip",
                                    ref: "nodes"
                                  }, {
                                    footer: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_40, [
                                        _createVNode(_component_Button, {
                                          type: "button",
                                          label: "Apply Filter",
                                          class: "w-12 h-2rem",
                                          onClick: _ctx.getFilteredParts
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "options"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.parts.length && _ctx.getFilters.length !== 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilters, (filter, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: filter.label,
                                      class: "col-2 card flex justify-content-center p-0 pr-1 mb-1"
                                    }, [
                                      _createVNode(_component_MultiSelect, {
                                        modelValue: _ctx.selectedFilterOptions[index].value,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.selectedFilterOptions[index].value) = $event),
                                        display: "chip",
                                        options: filter.tags,
                                        optionLabel: "label",
                                        placeholder: filter.label,
                                        class: "w-full",
                                        onChange: _ctx.removeMultiselectChip
                                      }, {
                                        footer: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_42, [
                                            _createVNode(_component_Button, {
                                              type: "button",
                                              label: "Apply Filter",
                                              class: "w-12 h-2rem",
                                              onClick: _ctx.getFilteredParts
                                            }, null, 8, ["onClick"])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange"])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.parts.length > 0 && _ctx.getFilters.length > 0)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 2,
                                  icon: "pi pi-filter-slash",
                                  onClick: _ctx.clearFilters,
                                  class: "col-1 m-0"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_ResultGridView, {
                            productList: _ctx.parts,
                            rangeEnd: _ctx.rangeEnd,
                            onAddPartToOrder: _ctx.addItem,
                            onOpenPartDetails: _ctx.onRowClick,
                            onNextRange: _ctx.fetchNextPartsRange
                          }, null, 8, ["productList", "rangeEnd", "onAddPartToOrder", "onOpenPartDetails", "onNextRange"])
                        ]))
                  ]))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ProductDialog, {
      open: _ctx.showProductDetails,
      selectedProduct: _ctx.selectedProduct,
      customerId: _ctx.getCustomer.cust_id,
      onAddProductToCart: _ctx.addItem,
      onCloseProductDialog: _ctx.closeDialog
    }, null, 8, ["open", "selectedProduct", "customerId", "onAddProductToCart", "onCloseProductDialog"])
  ], 64))
}